import { MedicineBoxOutlined } from '@ant-design/icons';

const TreatmentPlanHeader = ({ treatmentName, allDatesCount, dataSourceCount }) => {
    return (
        <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '20px 24px',
            color: 'white',
            margin: 0,
            borderRadius: "13px"
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '12px',
            }}>
                <div>
                    <h3 style={{
                        margin: 0,
                        fontSize: '20px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                    }}>
                        <MedicineBoxOutlined style={{ fontSize: '24px' }} />
                        Treatment Schedule {treatmentName ? `[${treatmentName}]` : ""}
                    </h3>
                    <p style={{
                        margin: '8px 0 0 0',
                        fontSize: '13px',
                        opacity: 0.9,
                    }}>
                        {allDatesCount} days • {dataSourceCount} services
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TreatmentPlanHeader;
